module.exports = __webpack_public_path__ + "img/1516990198.a35c2b13.jpg";